define.alias("ember-useragent/helpers/user-agent", "calendar/helpers/user-agent");